/* Custom by Mr Shoe (2 Nov 2026, Shau: "a way to contact us for quote if customers want to buy more… if click on
   contact us, it brings this form in pop up modal"). At the end of the product page's quantity limit note, a link (only
   there: Shau, of the basket lines and the line below Save, "no need to show it here", "no need here too") opens the
   Contact Us form (Powerful Form Builder) in that app's own pop-up, set to Product Enquiry with the product
   picked and the message started: the shopper adds their details and how many they need. Without the form app on the
   page the link goes to the Contact Us page. The limits come from GSE Components (gse-notes.js, gse-limits.js), whose
   markup this reads; settings are in snippets/mr-shoe-quote.liquid. */
(function () {
  var el = document.getElementById('mrs-quote-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }

  function app() { return window.Globo && window.Globo.FormBuilder; }
  function said(tpl, d) {
    return String(tpl).replace('{product}', d.product || 'this product').replace('{size}', d.size ? ' (' + d.size + ')' : '').split('{max}').join(String(d.max || ''));
  }
  function set(input, value) {
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // The app's own pop-up, opened as its links do (Globo.FormBuilder.openModalForm): shown again if it was opened
  // before, otherwise added to the page and drawn by the app.
  function openForm() {
    var fb = app();
    if (!fb || !fb.forms || !fb.forms[cfg.form] || typeof fb.initialize !== 'function') return false;
    var modal = document.querySelector('.globo-form-publish-modal.popup[data-id="' + cfg.form + '"]');
    if (modal) modal.style.display = 'block';
    else {
      document.body.insertAdjacentHTML('beforeend', '<div class="globo-form-publish-modal popup" data-id="' + cfg.form + '"><div class="globo-form-modal-content"><div class="globo-formbuilder addition-popup-type" data-id="' + cfg.form + '"></div></div></div>');
      fb.initialize();
    }
    return true;
  }

  // What the shopper is asking about: the selected size.
  function capFor(id) {
    var max = 0;
    document.querySelectorAll('[data-gse-caps]').forEach(function (c) {
      (c.getAttribute('data-gse-caps') || '').split('|').forEach(function (s) {
        var p = s.split('~'), m = parseInt(p[0], 10);
        if (m > 0 && (!p[1] || p[1].indexOf(',' + id + ',') >= 0) && (!max || m < max)) max = m;
      });
    });
    return max;
  }
  function pageInfo() {
    var id = (document.querySelector('form[action*="/cart/add"] input[name="id"]') || {}).value || '';
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var v = meta && meta.variants ? meta.variants.filter(function (x) { return String(x.id) === String(id); })[0] : null;
    var title = document.querySelector('.product-info .product-title, .product-title, h1');
    return Promise.resolve({ product: title ? title.textContent.trim() : '', size: (v && v.public_title) || '', max: capFor(id) });
  }

  // The form once the app has drawn it: Product Enquiry (which shows the Product field), the product picked from the
  // app's own product search, and the message started. An earlier enquiry's product is taken off first.
  function whenForm(done) {
    var tries = 0;
    (function look() {
      var form = document.querySelector('.globo-form-publish-modal.popup[data-id="' + cfg.form + '"] form');
      if (form) done(form); else if (++tries < 60) setTimeout(look, 100);
    })();
  }
  function fill(form, d) {
    // The app puts back an unsent draft a moment after drawing the form, so the topic and message are set again once
    // the product is picked (or after a second without a product).
    function words() {
      form.querySelectorAll('select').forEach(function (s) {
        for (var i = 0; i < s.options.length; i++) if (s.options[i].text.trim() === cfg.topic && s.value !== s.options[i].value) set(s, s.options[i].value);
      });
      var message = form.querySelector('textarea');
      if (message) set(message, said(d.max ? cfg.message : cfg.message_nomax, d));
    }
    words();
    var box = form.querySelector('[data-type="product"]'), search = box && box.querySelector('input[name^="search_product"]');
    if (!search || !d.product) { setTimeout(words, 1000); return; }
    // The Product field shows once Product Enquiry is picked. Its search starts on focus and reads what is typed, but
    // only once the app has it ready (a moment after the pop-up is drawn), so it is started again each second until
    // the product is in the results, then picked.
    box.querySelectorAll('.gfb-selected-product__remove').forEach(function (x) { x.click(); });
    var want = d.product.trim().toLowerCase(), tries = 0;
    (function pick() {
      var hit = null;
      box.querySelectorAll('.gfb-product-item-wrapper').forEach(function (w) {
        var c = w.querySelector('input[type="checkbox"]');
        if (!hit && c && (c.getAttribute('data-product-title') || '').trim().toLowerCase() === want) hit = w;
      });
      if (hit) {
        if (!hit.querySelector('input[type="checkbox"]').checked) hit.querySelector('.gfb-product-item-label').click();
        set(search, '');
        document.body.dispatchEvent(new MouseEvent('click', { bubbles: true })); // the app shuts its result list on a click elsewhere
        words();
        return;
      }
      if (tries % 7 === 0) {
        search.dispatchEvent(new Event('focus'));
        set(search, d.product);
        search.dispatchEvent(new Event('keyup', { bubbles: true }));
      }
      if (++tries < 60) setTimeout(pick, 150); else words();
    })();
  }

  function link(text, kind, info) {
    var a = document.createElement('a');
    a.href = cfg.page;
    a.className = 'mrs-quote-link mrs-quote-link--' + kind;
    a.textContent = text;
    a.addEventListener('click', function (e) {
      if (!openForm()) return; // no form app: the Contact Us page
      e.preventDefault();
      info().then(function (d) { whenForm(function (form) { fill(form, d); }); });
    });
    return a;
  }

  // Put back whenever the theme or GSE Components redraws.
  // - The link: at the end of the product page limit note's reason, on the same line (Shau: "same line as within our
  //   courier's weight allowance").
  // - "You already have N in your basket": moved below the Save button (Shau: "this to be below save") and shown
  //   shorter (Shau: "shorten this"), in a wrapper that hides with it. gse-notes.js still finds and rewrites the app's
  //   line there (it looks for it anywhere in the section); its words stay in the page, out of sight, and the wrapper
  //   says the setting's words with the app's number.
  function sync() {
    document.querySelectorAll('.gse-notes__item--limit .gse-notes__body').forEach(function (b) {
      if (b.querySelector('.mrs-quote-link')) return;
      // "Need more?" in the note's own words, only "Get a quote" a link (Shau: "need more? to not be hyperlinked"),
      // the two kept together on one line.
      var more = document.createElement('span');
      more.className = 'mrs-quote-more';
      if (cfg.lead) more.appendChild(document.createTextNode(cfg.lead + ' '));
      more.appendChild(link(cfg.text, 'note', pageInfo));
      var why = b.querySelector('.gse-notes__detail') || b;
      why.appendChild(document.createTextNode(' '));
      why.appendChild(more);
    });
    document.querySelectorAll('.gse-basket-full').forEach(function (m) {
      var save = (m.closest('product-form') || document).querySelector('swish-save');
      var wrap = m.parentElement && m.parentElement.classList.contains('mrs-quote-full') ? m.parentElement : null;
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'mrs-quote-full';
        (save || m).insertAdjacentElement('afterend', wrap);
        wrap.appendChild(m);
        var said = document.createElement('span');
        said.className = 'mrs-quote-full__text';
        said.setAttribute('role', 'status');
        wrap.appendChild(said);
      } else if (save && wrap.previousElementSibling !== save) save.insertAdjacentElement('afterend', wrap);
      var n = /(\d+)/.exec(m.textContent || ''), text = n && cfg.full ? cfg.full.split('{max}').join(n[1]) : (m.textContent || '');
      var shown = wrap.querySelector('.mrs-quote-full__text');
      if (shown && shown.textContent !== text) shown.textContent = text;
      if (wrap.hidden !== m.hidden) wrap.hidden = m.hidden;
    });
  }
  var timer = 0;
  function soon() { if (!timer) timer = setTimeout(function () { timer = 0; sync(); }, 60); }
  new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('gse:basket', soon);
  sync();
})();
